module.exports = "/static/assets/f6156ddbd0164c7960a2d4c4f96f7342.png";